import { ComparisonValueType, IntegrationType } from "./types/JourneySchema";

export type IntegrationBranchProperty = {
  id: string;
  path: string;
  label: string;
  valueType: ComparisonValueType;
};

const SHARED_ODS_SEARCH_PROPERTIES: IntegrationBranchProperty[] = [
  {
    id: "found",
    path: "found",
    label: "Record found",
    valueType: ComparisonValueType.Boolean,
  },
];

const GOOGLE_PLACE_SEARCH_PROPERTIES: IntegrationBranchProperty[] = [
  {
    id: "found",
    path: "found",
    label: "Place found",
    valueType: ComparisonValueType.Boolean,
  },
];

const CATALOG: Partial<Record<IntegrationType, IntegrationBranchProperty[]>> = {
  [IntegrationType.SharedoOdsSearch]: SHARED_ODS_SEARCH_PROPERTIES,
  [IntegrationType.GooglePlaceSearch]: GOOGLE_PLACE_SEARCH_PROPERTIES,
};

export function getIntegrationBranchProperties(
  integrationType: IntegrationType
): IntegrationBranchProperty[] {
  return CATALOG[integrationType] ?? [];
}

export function findIntegrationBranchProperty(
  integrationType: IntegrationType,
  propertyId: string
): IntegrationBranchProperty | undefined {
  return getIntegrationBranchProperties(integrationType).find((p) => p.id === propertyId);
}

export function isIntegrationBranchPropertyId(
  integrationType: IntegrationType,
  propertyId: string
): boolean {
  return findIntegrationBranchProperty(integrationType, propertyId) != null;
}
